import { api } from "./api";

const returnApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getReturns: builder.query({
      query: () => "return-two",
      providesTags: ["return-two"],
    }),
    addReturn: builder.mutation({
      query: (newCategory) => ({
        url: "return-two",
        method: "POST",
        body: newCategory,
      }),
      invalidatesTags: ["return-two"],
    }),
    removeReturn: builder.mutation({
      query: (id) => ({
        // url: `orders2/${id}`,
        url: `returnTwo?return_no=${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["return-two"],
    }),
    editReturn: builder.mutation({
      query: (editData) => ({
        url: `return-two`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["return-two"],
    }),
  }),
});

export const {
  useGetReturnsQuery,
  useAddReturnMutation,
  useRemoveReturnMutation,
  useEditReturnMutation,
} = returnApi;